import { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppHeader from '@/component/common/app-header';
import SFBottomNavigation from '@/component/common/sf-bottom-navigator';
import SFWhiteButton from '@/component/common/sf-white-button';
import SFRefreshIcon from '@/component/icons/sf-refresh-icon';
import SwitchWithText from '@/component/point/switch-with-text';
import { inter } from '@/theme';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import BarcodeIgm from '@/assets/images/point-barcode-inactive.png';

import { useUserInfo, useUserInfoActions } from '@/store/zustand/store';
import PointTotal from '@/component/users/point/PointTotal';
import BarCodeType from '@/lib/Qrcode/BarCodeType';
import { barCode } from '@/api/server/point/read';
import ErrorRes from '@/api/server/ErrorRes';
import { users } from '@/api/server/user/read';
import { SFPalette } from '@/lib/color';
import { Button } from '@mui/material';
import BannerList from '@/component/banner/BannerList';
import BottomFix from '@/component/common/bottom-fix';
import { loginLocalStorage } from '@/lib/storage';

export default function PointMain() {
  const navigate = useNavigate();
  const theme = useTheme();
  const userInfo = useUserInfo();
  const { setUserInfo } = useUserInfoActions();
  const [isClick, setIsClick] = useState(false);
  const [types, setTypes] = useState('first');
  const [barcodeData, setBarcodeData] = useState('');

  useEffect(() => {
    console.log(userInfo);
    if (userInfo.level !== '3' && userInfo.name === 'member') {
      (async () => {
        const re = await users();
        if (re.ret_code !== 200) {
          ErrorRes({ code: re.ret_code, msg: re.msg });
          return;
        }
        const name = re.data?.real_name || 'member';

        const payload = {
          email: loginLocalStorage().email,
          name,
          referral: re.data.recommender_nm,
          level: re.data.auth_lv_num,
        };
        setTimeout(() => {
          setUserInfo(payload);
        }, 1000);
      })();
    }

    return () => {};
  }, []);

  // 바코드, qr
  useEffect(() => {
    if (isClick) {
      (async () => {
        // TODO 타이머 추가하자
        await getBarCode();
      })();
    }
    return () => {};
  }, [isClick]);

  const getBarCode = async () => {
    const re = await barCode();
    if (re.ret_code !== 200) {
      ErrorRes({ code: re.ret_code, msg: re.msg });
      return;
    }
    setBarcodeData(re.data);
  };
  return (
    <Box bgcolor={theme.palette.primary.main} minHeight={750}>
      <Box display="flex" flexDirection="column" height="100%" gap={4}>
        <Container maxWidth="sm">
          <AppHeader title="포인트" />
          <Box>
            <Stack mt={4} direction="row" gap={1.5} alignItems="center">
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  border: '2px solid white',
                }}
              />
              <Typography variant="h5" color="white">
                <strong>{userInfo.name}</strong> 님의 셔플포인트
              </Typography>
              <SFRefreshIcon />
            </Stack>
            <Typography
              variant="h2"
              color="white"
              mt={1.5}
              textAlign="right"
              mb={2.5}
              fontFamily={inter.style.fontFamily}
            >
              <PointTotal />
            </Typography>
            <Grid container spacing={1.5}>
              <Grid item xs={7}>
                <SFWhiteButton
                  fullWidth
                  size="large"
                  variant="contained"
                  sx={{
                    borderRadius: '100px !important',
                  }}
                  onClick={() => {
                    if (userInfo.email === 'jh.koo@hupayx.com') {
                      // 인앱결제 테스트 용
                      navigate('/charge2');
                    } else {
                      navigate('/charge');
                    }
                  }}
                >
                  <Typography variant="h6" fontWeight={700}>
                    충전하기
                  </Typography>
                </SFWhiteButton>
              </Grid>
              <Grid item xs={5}>
                {userInfo.level === '3' ? (
                  <SFWhiteButton
                    fullWidth
                    size="large"
                    variant="outlined"
                    sx={{
                      borderRadius: '100px !important',
                    }}
                    onClick={() => {
                      navigate('/pointDetail');
                    }}
                  >
                    <Typography variant="h6" fontWeight={700}>
                      이용 내역
                    </Typography>
                  </SFWhiteButton>
                ) : (
                  <SFWhiteButton
                    fullWidth
                    size="large"
                    variant="outlined"
                    sx={{
                      borderRadius: '100px !important',
                    }}
                    onClick={() => {
                      navigate('/pointDetail');
                    }}
                    disabled
                  >
                    <Typography variant="h6" fontWeight={700}>
                      이용 내역
                    </Typography>
                  </SFWhiteButton>
                )}
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Box
          pt={5}
          // pb={4}
          flex={1}
          left={0}
          bottom={0}
          width="100%"
          sx={{
            bgcolor: 'white',
            '&': {
              borderTopLeftRadius: '30px',
              borderTopRightRadius: '30px',
            },
          }}
        >
          {userInfo.level !== '3' ? <div style={{ textAlign: 'center' }}> '포인트 가입준비 중'</div> : ''}
          <Container maxWidth="sm">
            <SwitchWithText firstText="바코드" secondText="QR코드" setTypes={setTypes} />
            {isClick ? (
              <>
                <Button
                  onClick={() => {
                    getBarCode();
                  }}
                >
                  <SFRefreshIcon color={SFPalette.grey3} />
                </Button>
                {BarCodeType({ isBarcode: types === 'first' ? true : false, value: barcodeData })}
              </>
            ) : (
              <Box textAlign="center" mb={6.5}>
                <img
                  src={BarcodeIgm}
                  alt="Barcode"
                  width={248}
                  height={145}
                  onClick={() => {
                    setIsClick(true);
                  }}
                />
              </Box>
            )}
          </Container>
        </Box>
      </Box>
      <BottomFix enableHeight={false}>
        <BannerList />
        <SFBottomNavigation selectedLabel="포인트" />
      </BottomFix>
    </Box>
  );
}
